var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('addresses-base',{attrs:{"addresses":_vm.addresses},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var addressList = ref.addressList;
return [_c('div',{},[_c('transition-group',{staticClass:"flex flex-wrap items-center",attrs:{"name":"list-complete","tag":"div"}},_vm._l((addressList),function(address){return _c('address-item',{key:address.id,attrs:{"address":address}})}),1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }